<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="bulk-action d-flex">
    <div ngbDropdown class="dropdown select-action-group">
        <button class="bulk-action-button dropdown-toggle btn btn-sm"
                type="button"
                ngbDropdownToggle
                aria-haspopup="true"
                aria-expanded="false"
                aria-hidden="true"
                aria-label="Select Action Menu">
            <label class="checkbox-container">
                <input type="checkbox"
                       [checked]="status === 'ALL'"
                       [indeterminate]="status === 'SOME' || status === 'PAGE'"
                       (change)="toggleSelection(status)"
                       aria-hidden="true">
                <span class="checkmark"></span>
            </label>
            <span class="bulk-action-selected-number">
                <ng-container *ngIf="count() > 0"> <scrm-label class="d-none d-sm-inline" labelKey="LBL_LISTVIEW_SELECTED_OBJECTS"></scrm-label></ng-container> {{count() > 0 ? count() : ''}}
            </span>
        </button>
        <div class="dropdown-menu"
             ngbDropdownMenu
             aria-hidden="true">
            <a class="dropdown-item select-all" (click)="selectAll()">
                <scrm-label labelKey="LBL_LISTVIEW_OPTION_ENTIRE"></scrm-label>
            </a>
            <a class="dropdown-item select-page" (click)="selectPage()">
                <scrm-label labelKey="LBL_LISTVIEW_OPTION_CURRENT"></scrm-label>
            </a>
            <a class="dropdown-item deselect-all" (click)="deselectAll()">
                <scrm-label labelKey="LBL_LISTVIEW_NONE"></scrm-label>
            </a>
        </div>
    </div>
    <scrm-dropdown-button class="d-block d-sm-none"
                          [disabled]="count() < 1"
                          [config]="dropdownSmallConfig">
    </scrm-dropdown-button>
    <scrm-dropdown-button class="d-none d-sm-block"
                          [disabled]="count() < 1"
                          [config]="dropdownConfig">
    </scrm-dropdown-button>

</div>
